import { PAF_VIEW } from '@/fixtures'

export default {
  path: 'payment-auth',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Payment Authorization Form',
      component: () => import('@/views/menus/PaymentAuth/Index'),
      meta: {
        permission: PAF_VIEW
      }
    },
    {
      path: 'detail',
      name: 'Detail Payment Authorization Form',
      component: () => import('@/views/menus/PaymentAuth/View'),
      meta: {
        permission: PAF_VIEW
      }
    }
  ]
}
